const typography = "_typography_yh5dq_162";
const styles = {
  "font-body-xs-regular": "_font-body-xs-regular_yh5dq_21",
  "font-body-xs-semibold": "_font-body-xs-semibold_yh5dq_26",
  "font-body-xs-medium": "_font-body-xs-medium_yh5dq_31",
  "font-body-sm-regular": "_font-body-sm-regular_yh5dq_40",
  "font-body-sm-semibold": "_font-body-sm-semibold_yh5dq_45",
  "font-body-sm-medium": "_font-body-sm-medium_yh5dq_50",
  "font-body-md-regular": "_font-body-md-regular_yh5dq_59",
  "font-body-md-semibold": "_font-body-md-semibold_yh5dq_64",
  "font-body-md-medium": "_font-body-md-medium_yh5dq_69",
  "font-body-lg-regular": "_font-body-lg-regular_yh5dq_78",
  "font-body-lg-semibold": "_font-body-lg-semibold_yh5dq_83",
  "font-body-lg-medium": "_font-body-lg-medium_yh5dq_88",
  "font-heading-sm-regular": "_font-heading-sm-regular_yh5dq_97",
  "font-heading-sm-semibold": "_font-heading-sm-semibold_yh5dq_102",
  "font-heading-sm-medium": "_font-heading-sm-medium_yh5dq_107",
  "font-heading-md-regular": "_font-heading-md-regular_yh5dq_116",
  "font-heading-md-semibold": "_font-heading-md-semibold_yh5dq_121",
  "font-heading-lg-regular": "_font-heading-lg-regular_yh5dq_130",
  "font-heading-lg-semibold": "_font-heading-lg-semibold_yh5dq_135",
  "font-heading-xl-regular": "_font-heading-xl-regular_yh5dq_144",
  "font-heading-xl-semibold": "_font-heading-xl-semibold_yh5dq_149",
  typography
};
export {
  styles as default,
  typography
};
//# sourceMappingURL=Typography.module.css.js.map
